// A one-shot, in-memory handoff from an explicit Send click. Never restored on reload.
let pending = null;
export function queueDiscoveryContinuation({ conversationId, userId, session, prompt, now = Date.now() }) {
  if (!conversationId || !userId || !prompt?.trim()) return;
  pending = { conversationId, userId, session, prompt: prompt.trim(), expires: now + 60000 };
}
export function takeDiscoveryContinuation({ conversationId, userId, session, now = Date.now() }) {
  if (!pending) return null;
  if (pending.expires < now || pending.userId !== userId || pending.session !== session) { pending = null; return null; }
  if (pending.conversationId !== conversationId) return null;
  const value = pending; pending = null; return value.prompt;
}
